import Vue from 'vue';
import Component from 'vue-class-component';
import Modal from '../../models/Modal';

/**
 * Confirmation modal which is used to confirm a critical action.
 *
 * @remarks
 * All data is fetched from the store.
 */
@Component({
  name: 'ConfirmationModal',
  inheritAttrs: false,
})
export default class ConfirmationModal extends Vue {
  get modal(): Modal {
    return this.$store.state.modal;
  }

  /**
   * Executes the callback received from the store and closes the modal afterwards.
   */
  private handleConfirmation() {
    if (this.modal.confirmationCallback) this.modal.confirmationCallback();
    (document.getElementById('modal') as HTMLSdxDialogElement).close();
  }
}
